
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Header from './Header.js';
import { DataContext } from './DataContextProvider.js';
import DataTable from './DataTable.js';

export default function EditList() {
  const { id } = useParams();
  const [listArticles, setListArticles] = React.useState([2770]);
  const navigate = useNavigate();
  const dataContext = React.useContext(DataContext);

  React.useEffect(() => {
    (async () => {
      let r = await fetch('/api/lists/' + id);
      let list = await r.json();
      setListArticles(list.articles);
    })();
  }, [id]);

  const done = () => {
    dataContext.forceUpdate();
    navigate('/lists/' + id);
  };

  const addOrRemove = (ev) => {
    const article_id = parseInt(ev.target.id);
    if (!listArticles.includes(article_id)) {
      // add to list
      fetch('/api/lists/' + id + '/articles/' + article_id, {
        method: 'POST',
      });
      setListArticles([...listArticles, article_id]);
    }
    else {
      // remove from list
      fetch('/api/lists/' + id + '/articles/' + article_id, {
        method: 'DELETE',
      });
      setListArticles(listArticles.filter(a => a !== article_id));
    }
  };

  const addCheckbox = (id, flag, item) => {
    return (
      <>
        <Form.Check id={id} type="checkbox" defaultChecked={listArticles.includes(id)} onChange={addOrRemove} className="article-select" />
        &nbsp;
        {item}
      </>
    );
  };

  return (
    <>
      <Header title="Edit List" location={'/lists/' + id + '/edit'}>
        <Button variant="secondary" onClick={done}>Done</Button>
      </Header>
      <DataTable item="articles" title="Articles" paginate={true} extra={addCheckbox}/>
    </>
  );
}
